import React, { useEffect, useState } from 'react'

import Logo_school from "../assets/Logo_school.png"


// icons start 
import { MdDashboardCustomize } from "react-icons/md";
import { FaUserAstronaut } from "react-icons/fa";
import { MdContentPasteGo } from "react-icons/md";
import { GrSettingsOption } from "react-icons/gr";
import { FaUserShield } from "react-icons/fa";
import { GrLogout } from "react-icons/gr";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API } from './constant';
// icons end 

const Sidebar = ({ children }) => {

  const [userData, setuserData] = useState([])
  const [userRole, setuserRole] = useState("")
  // console.log(userData)
  useEffect(() => {
    axios.get(`${API}/login/logged-in-user`, {
      headers: {
        "Content-Type": "application/json",
        "token": localStorage.getItem("token")
      }
    })
      .then((res) => {
        // console.log(res.data)
        setuserData(res.data.data)
        setuserRole(res.data.data.role)
      })
      .catch((error) => {
        console.log(error)
      })
  }, [])

  const handleLogout = () => {
    localStorage.removeItem("token")
    window.location.href = "/login"
  }



  // find default session and default assessment period

  const [fetchedSession, setfetchedSession] = useState("")
  const [fetchedAssessmentPeriod, setfetchedAssessmentPeriod] = useState("")
  useEffect(() => {
    axios.get((`${API}/default-session/689ada445027a6bbae0adf3a`))
      .then((res) => {
        // console.log(res.data.data.default_session)
        setfetchedSession(res.data.data.default_session)
      })
      .catch((error) => {
        console.log(error)
      })
  }, [])

  useEffect(() => {
    axios.get((`${API}/default-assessment-period/689ad9de5027a6bbae0adf38`))
      .then((res) => {
        // console.log(res.data.data.default_month)
        setfetchedAssessmentPeriod(res.data.data.default_month)
      })
      .catch((error) => {
        console.log(error)
      })
  }, [])

  return (
    <div className='flex'>
      <div className='w-[17%] h-[100vh] flex flex-col sidebar border-r-[1px] border-theme_border'>
        <div className='img_logo w-full h-[25%] bg-theme_blue flex justify-center items-center px-[20px] py-[20px]'>
          <img src={Logo_school} alt="" />

        </div>
        <div className='w-full bg-theme_border flex flex-col   justify-between overflow-auto flex-1 '>
          <div>
            <ul className='border-theme_border border-2px border-solid'>
              {/* <Link to="/dashboard" className='text-theme_black hover:no-underline'>
                <li className='px-[10px] py-[10px] sidebar_menu '><span><MdDashboardCustomize /></span> <span>Dashboard</span></li>
              </Link> */}

              <Link to="/students" className='text-theme_black hover:no-underline'>
                <li className='px-[10px] py-[10px] sidebar_menu'><span><FaUserAstronaut /></span> <span>Students</span></li>
              </Link>
              {
                (userRole === "Admin" || userRole === "Super Admin") && (
                  <>
                    <Link to="/manage-content" className='text-theme_black hover:no-underline'>
                      <li className='px-[10px] py-[10px] sidebar_menu'><span><MdContentPasteGo /></span> <span>Manage content</span></li>
                    </Link>

                  </>
                )
              }

              {
                userRole === "Super Admin" && (
                  <>
                    <Link to="/masters" className='text-theme_black hover:no-underline'>
                      <li className='px-[10px] py-[10px] sidebar_menu'><span><GrSettingsOption /></span> <span>Masters</span></li>
                    </Link>
                  </>
                )
              }


              {
                userRole === "Super Admin" && (
                  <>
                    <Link to="/users" className='text-theme_black hover:no-underline'>
                      <li className='px-[10px] py-[10px] sidebar_menu'><span><FaUserShield /></span> <span>Users</span></li>
                    </Link>
                  </>
                )
              }
            </ul>
          </div>

          <div>
            <ul>
              <li onClick={handleLogout} className='px-[10px] py-[10px] sidebar_menu sidebar_menu_logout '><span><GrLogout /></span> <span>Logout</span></li>
            </ul>
          </div>
        </div>
      </div>

      <div className='content_area w-[83%] '>
        <div className='bg-theme_blue h-[15vh] w-full flex items-center px-[20px] text-theme_white'>
          <div className='w-full'>
            <h2>Welcome {userData.name}</h2>
            <div className='text-sm flex justify-between'>
              <div>
              <p>{userData.school_location}</p>
              <p className='text-[12px]'>{userRole}</p>
              </div>
              
                <p>Current session:{fetchedSession}, {fetchedAssessmentPeriod}</p>
                
             
            </div>

          </div>
        </div>
        {children}
      </div>

    </div>
  )
}

export default Sidebar